import * as React from 'react'

const PayAfterSvg = (props) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#E0EAFF" />
    <path
      d="M23.3333 16.6666V13.7505C23.3333 13.0574 23.3333 12.7109 23.1873 12.4979C23.0598 12.3118 22.8622 12.1854 22.6398 12.1475C22.3852 12.1042 22.0706 12.2495 21.4413 12.5399L14.0492 15.9516C13.4879 16.2107 13.2073 16.3402 13.0018 16.5411C12.82 16.7187 12.6813 16.9354 12.5963 17.1748C12.5 17.4456 12.5 17.7547 12.5 18.3729V22.5M23.75 22.0833H23.7583M12.5 19.3333L12.5 24.8333C12.5 25.7667 12.5 26.2334 12.6817 26.59C12.8414 26.9036 13.0964 27.1585 13.41 27.3183C13.7665 27.5 14.2332 27.5 15.1667 27.5H24.8333C25.7668 27.5 26.2335 27.5 26.59 27.3183C26.9036 27.1585 27.1586 26.9036 27.3183 26.59C27.5 26.2334 27.5 25.7667 27.5 24.8333V19.3333C27.5 18.3999 27.5 17.9332 27.3183 17.5767C27.1586 17.2631 26.9036 17.0081 26.59 16.8483C26.2335 16.6666 25.7668 16.6666 24.8333 16.6666L15.1667 16.6666C14.2332 16.6666 13.7665 16.6666 13.41 16.8483C13.0964 17.0081 12.8414 17.2631 12.6817 17.5767C12.5 17.9332 12.5 18.3999 12.5 19.3333ZM24.1667 22.0833C24.1667 22.3134 23.9801 22.5 23.75 22.5C23.5199 22.5 23.3333 22.3134 23.3333 22.0833C23.3333 21.8532 23.5199 21.6666 23.75 21.6666C23.9801 21.6666 24.1667 21.8532 24.1667 22.0833Z"
      stroke="#444CE7"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default PayAfterSvg
